export const MAX_JAVASCRIPT_TIMER_MS = 2_147_483_647;

export const resolveApiRequestTimeout = (
  value: unknown,
  variableName = 'VITE_API_REQUEST_TIMEOUT_MS',
): number => {
  if (value === undefined || value === '') {
    return 0;
  }

  const parsed = typeof value === 'string' && /^\d+$/.test(value)
    ? Number(value)
    : Number.NaN;

  if (!Number.isSafeInteger(parsed) || parsed <= 0 || parsed > MAX_JAVASCRIPT_TIMER_MS) {
    throw new Error(`Invalid ${variableName}`);
  }

  return parsed;
};
